import FilesTab from "@/components/FilesTab";
import { FolderOpen } from "@phosphor-icons/react";

export default function AssistantPage() {
  return (
    <div className="fade-in max-w-3xl" data-testid="assistant-page">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-widest text-muted-foreground mb-1 flex items-center gap-1.5">
          <FolderOpen size={12} weight="fill" className="text-[#0084ff]" /> Ваше личное облако файлов
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">Файлообменник</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Загружайте фото, PDF, документы, аудио и видео — AI прочитает их и разложит по папкам.
          Делитесь файлами по ссылке с кем угодно или отправляйте в семейный чат.
        </p>
      </div>
      <FilesTab />
    </div>
  );
}
